/** @license See the LICENSE file. */
// This code is auto-generated, do not modify this file!
const version = '3.8.0';
export { version };
//# sourceMappingURL=version.js.map